import React, { useEffect } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { urlApi } from "../constants";

const PrivateRoutes = () => {
  let userInfo = localStorage.getItem("user_info");

  useEffect(() => {
    if (userInfo) {
      const token = JSON.parse(userInfo).access_token;
      try {
        fetch(urlApi + "/v1/dashboard/card", {
          method: "GET",
          headers: {
            Accept: "application/json",
            "content-Type": "application/json",
            "Access-Control-Allow-Headers": "*",
            Authorization: "Bearer " + token,
          },
        })
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            if (
              data.errors &&
              data.errors.includes("Token has expired. Please log in again.")
            ) {
              localStorage.removeItem("user_info");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } catch {
        (e) => console.log(e);
      }
    }
  }, []);
  return userInfo ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoutes;
